export default "__VITE_ASSET__bb1008ae__"